import { c as _c } from "react/compiler-runtime";
import { DotPulse } from 'ldrs/react';
import 'ldrs/react/DotPulse.css';
import type { ElementType, PropsWithChildren } from 'react';
import { cx } from '../../cx';
import type { ButtonAsProps } from '../../polymorphic-props';
import type { ButtonProps } from './button';
import { Button } from './button';
export type LoadingButtonProps = ButtonProps & {
  isLoading?: boolean;
};
export function LoadingButton(props) {
  const $ = _c(23);
  let children;
  let disabled;
  let isLoading;
  let ref;
  let rest;
  if ($[0] !== props) {
    ({
      ref,
      isLoading,
      disabled,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = disabled;
    $[3] = isLoading;
    $[4] = ref;
    $[5] = rest;
  } else {
    children = $[1];
    disabled = $[2];
    isLoading = $[3];
    ref = $[4];
    rest = $[5];
  }
  const t0 = isLoading ? "invisible" : "";
  let t1;
  if ($[6] !== rest.classNames || $[7] !== t0) {
    t1 = {
      ...rest.classNames,
      icon: t0
    };
    $[6] = rest.classNames;
    $[7] = t0;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const t2 = isLoading || disabled;
  let t3;
  if ($[9] !== isLoading) {
    t3 = isLoading && <span className="absolute inset-0 z-10 flex items-center justify-center"><DotPulse speed={1.3} color="currentColor" /></span>;
    $[9] = isLoading;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== isLoading) {
    t4 = cx({
      "text-transparent": isLoading
    });
    $[11] = isLoading;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== children || $[14] !== t4) {
    t5 = <span className={t4}>{children}</span>;
    $[13] = children;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== ref || $[17] !== rest || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
    t6 = <Button {...rest} classNames={t1} disabled={t2} ref={ref}>{t3}{t5}</Button>;
    $[16] = ref;
    $[17] = rest;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}